import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HomeModuleRoutingModule } from './home-module-routing.module';
import {MaterialModule} from "../../material/material.module";


import { HomeComponent } from './home/home.component';
import { AboutUSComponent } from './Modal/about-us/about-us.component';
import { ProductComponent } from './Modal/product/product.component';
import { CSRComponent } from './Modal/csr/csr.component';
import { FrontSideComponent } from './front-side/front-side.component';
import { BusinessPolicyComponent } from './Modal/business-policy/business-policy.component';
import { WebRegistrationComponent } from './Modal/web-registration/web-registration.component';
import { LoginComponent } from './Modal/login/login.component';
import { ForgotPassComponent } from './Modal/forgot-pass/forgot-pass.component';
import { RegistrationComponent } from './Modal/registration/registration.component';

import { AuthService } from '../services/auth.service';
import { useractivationService } from './../../admin/services/useractivation.service';



import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule,HTTP_INTERCEPTORS } from "@angular/common/http";

import { SharedModuleModule }  from './../../common/shared-module/shared-module.module';
import { CSRPolicyComponent } from './Modal/csrpolicy/csrpolicy.component';
import { MGTComponent } from './Modal/mgt/mgt.component';
import { MGTRequestComponent } from './Modal/mgt/mgtrequest/mgtrequest.component';




@NgModule({
  declarations: [
    HomeComponent,
    AboutUSComponent,
    ProductComponent,
    CSRComponent,
    FrontSideComponent,
    BusinessPolicyComponent,
    WebRegistrationComponent,
    LoginComponent,
    ForgotPassComponent,
    RegistrationComponent,
    CSRPolicyComponent,
    MGTComponent,
    MGTRequestComponent,
  ],
  imports: [
    CommonModule,
    HomeModuleRoutingModule,
    MaterialModule,
    FormsModule, 
    ReactiveFormsModule,
    HttpClientModule,
    SharedModuleModule
  ],
  providers: [AuthService, useractivationService],

})
export class HomeModuleModule { }
